export default __webpack_public_path__ + "static/media/elite icon wht.5e8ed2d6.svg";